import { useState } from 'react';
import DsFormStep from './Steps';
import ThankYouPage from '../ThankYouPage';
export default function DsRequestPreview({
    platform,
    value,
    submitData,
    setSubmitData,
    applicantInformation,
    personalInformation,
    detailsOfClaim,
    evidenceInformation,
    policyAndTermsOfService,
    customForm,
    customStyle,
    fontStyle,
    logo,
    companyLogo,
    lang,
    reset,
    setReset,
    personalTypeList,
    requestType,
}) {
    const [pageChange, setPageChange] = useState(true);
    return pageChange ? (
        <DsFormStep
            requestType={requestType}
            platform={platform}
            value={value}
            submitData={submitData}
            setSubmitData={setSubmitData}
            applicantInformation={applicantInformation}
            personalInformation={personalInformation}
            detailsOfClaim={detailsOfClaim}
            evidenceInformation={evidenceInformation}
            policyAndTermsOfService={policyAndTermsOfService}
            customForm={customForm}
            customStyle={customStyle}
            fontStyle={fontStyle}
            logo={logo}
            companyLogo={companyLogo}
            lang={lang}
            setPageChange={setPageChange}
            reset={reset}
            setReset={setReset}
            personalTypeList={personalTypeList}
        />
    ) : (
        <ThankYouPage customForm={customForm} />
    );
}
